import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';

const SalesPlanBulkEditUpdatedHoc = () => {
  return (
    <div>
      <Navbar heading="FDP Updated - Sales Plan Bulk Edit" searchComponent={<></>} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};

export default SalesPlanBulkEditUpdatedHoc;
